module.exports = __webpack_public_path__ + "img/bright-theme.1281c59a.png";